import * as React from "react";
import { observer } from "mobx-react";
import { FlightCardProps } from "components/flexComponents/Flights/typings";
import { FlightCardDefaultContent } from "components/flexComponents/Flights/components/FlightCardDefaultContent";
import { FlightCardFilteredContent } from "components/flexComponents/Flights/components/FlightCardFilteredContent";
import { FlightCardWithButtonContent } from "components/flexComponents/Flights/components/FlightCardWithButton/FlightCardWithButtonContent";
import { FlightsViews } from "components/flexComponents/Flights/util/typings";

interface FlightViews {
  [FlightsViews.FILTERED]: React.JSX.Element;
  [FlightsViews.WITH_BUTTON]: React.JSX.Element;
}

export const FlightCard: React.FC<FlightCardProps> = observer(
  ({ flight, index, isMobile, isTablet, view, showCityName }) => {
    const defaultFlightView = (
      <FlightCardDefaultContent
        flight={flight}
        index={index}
        isMobile={isMobile}
        isTablet={isTablet}
        showCityName={showCityName}
      />
    );
    const filteredFlightView = <FlightCardFilteredContent flight={flight} index={index} showCityName={showCityName} />;
    const withButtonFlightView = (
      <FlightCardWithButtonContent flight={flight} index={index} isMobile={isMobile} showCityName={showCityName} />
    );
    const flightViews: FlightViews = {
      [FlightsViews.FILTERED]: filteredFlightView,
      [FlightsViews.WITH_BUTTON]: withButtonFlightView,
    };

    return flightViews[view as keyof FlightViews] ?? defaultFlightView;
  }
);
